module.exports = __webpack_public_path__ + "img/menu_logs.9f9b6895.svg";